<template>
  <div class="upload-file-multiple">
    <!-- 当前文件列表文件展示 -->
    <div v-for="(item, index) in urlArr" :key="index">
      <upload-file
        :modelValue="item"
        @update:modelValue="(e) => updateMyValue(e, index)"
        v-bind="{...uploadFileOptions, isShowDelete: !isDetailShow}">
      </upload-file>
    </div>
    <!-- 添加 -->
    <upload-file
      v-if="urlArr.length < maxCount && !isDetailShow"
      modelValue=""
      @update:modelValue="(e) => updateMyValue(e)"
      v-bind="{...uploadFileOptions, isShowDelete: !isDetailShow}"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  // 绑定的值, 为数组
  modelValue: {
    type: Array,
    required: true,
    default: []
  },
  // 单个<upload-file>组件配置参数
  uploadFileOptions: {
    type: Object,
    default: {}
  },
  // 最大文件上传数目
  maxCount: {
    type: Number,
    default: 3
  },
  // 是否是仅详情查看, 如果是，则不能进行任何操作
  isDetailShow: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])

const urlArr = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

function updateMyValue(val, index) {
  if (val) {
    // 添加
    urlArr.value.push(val)
  } else {
    // 删除
    urlArr.value.splice(index, 1)
  }
}
</script>

<style lang="scss" scoped>
.upload-file-multiple {
  display: flex;

  .upload-file {
    margin-right: 8px;
  }
}
</style>